import { useContext } from "react";

import { FeatureFlagsContext } from "@contexts/FeatureFlagsProvider";

const useFeatureFlags = () => useContext(FeatureFlagsContext);

export default useFeatureFlags;
